/*
* Broadcast Theme - Calviero Custom JS
* GLO Color Swatch <-> Broadcast Theme Image Bridge
* Fixes: variant image not switching when color swatch is clicked
*/

(function() {
  'use strict';

  var lastVariantId = null;

  function getProductSection() {
    return document.querySelector('[data-section-type="product"]');
  }

  function syncVariantImage(variantId) {
    variantId = parseInt(variantId);
    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    var section = getProductSection();
    if (!section) return;

    var productJsonEl = section.querySelector('[data-product-json]');
    var productImages = section.querySelector('product-images');
    if (!productJsonEl || !productImages) return;

    try {
      var product = JSON.parse(productJsonEl.textContent);
      var sectionId = section.dataset.sectionId;
      var variant = product.variants.find(function(v) { return v.id === variantId; });
      if (!variant) return;

      if (variant.featured_image) {
        var mediaId = sectionId + '-' + variant.featured_image.id;
        productImages.dispatchEvent(new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: { id: mediaId }
        }));
        return;
      }

      var colorOption = product.options.find(function(o) {
        return o.name.toLowerCase() === 'color' || o.name.toLowerCase() === 'colour';
      });
      if (!colorOption) return;

      var colorIndex = product.options.indexOf(colorOption);
      var colorValue = variant.options[colorIndex];
      if (!colorValue) return;

      var mediaItems = productImages.querySelectorAll('[data-media-id]');
      for (var i = 0; i < mediaItems.length; i++) {
        var img = mediaItems[i].querySelector('img[alt]');
        if (img && img.alt.toLowerCase() === colorValue.toLowerCase()) {
          productImages.dispatchEvent(new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: { id: mediaItems[i].dataset.mediaId }
          }));
          break;
        }
      }
    } catch (e) {}
  }

  var origReplace = history.replaceState;
  history.replaceState = function(state, title, url) {
    origReplace.apply(this, arguments);
    var match = (url || '').match(/[?&]variant=(\d+)/);
    if (match) setTimeout(function() { syncVariantImage(match[1]); }, 20);
  };

  var origPush = history.pushState;
  history.pushState = function(state, title, url) {
    origPush.apply(this, arguments);
    var match = (url || '').match(/[?&]variant=(\d+)/);
    if (match) setTimeout(function() { syncVariantImage(match[1]); }, 20);
  };

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) syncVariantImage(e.detail.variant.id);
  });

  setInterval(function() {
    var section = getProductSection();
    if (!section) return;
    var idInput = section.querySelector('input[name="id"]');
    if (idInput && idInput.value) syncVariantImage(idInput.value);
  }, 250);

  function initSync() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) syncVariantImage(m[1]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }

})();
